export default "__VITE_ASSET__BWjjJB8v__"